import { formatEther, parseEther } from 'ethers/lib/utils.js';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { ChartContainer } from '../ActivityCharts';
import { useTheme } from 'next-themes';

const options = (listingPrices, orderPrices, theme, actualPrice) => ({
  chart: {
    type: 'area',
    zoomType: 'xy',
    backgroundColor: 'transparent',
  },
  title: {
    text: 'Market Depth',
    style: {
      color: theme === 'dark' ? '#fff' : '#000',
      fontSize: '16px',
      fontWeight: 'bold',
    },
  },
  xAxis: {
    minPadding: 0,
    maxPadding: 0,
    plotLines: [
      {
        color: '#888',
        // value: 0.1523,
        width: 1,
        label: {
          text: 'Actual price',
          rotation: 90,
          style: {
            fontStyle: 'italic',
            color: theme === 'dark' ? '#fff' : '#000',
          },
          // align: 'center',
          // x: -5,
        },
        value: Number(actualPrice),
      },
    ],
    title: {
      text: 'Price Volume',
      style: {
        color: theme === 'dark' ? '#fff' : '#000',
      },
    },
    labels: {
      style: {
        color: theme === 'dark' ? '#fff' : '#000',
      },
    },
  },
  yAxis: [
    {
      lineWidth: 1,
      gridLineWidth: 1,
      title: null,
      tickWidth: 1,
      tickLength: 5,
      tickPosition: 'inside',
      labels: {
        align: 'right',
        x: -10,
        style: {
          color: theme === 'dark' ? '#fff' : '#000',
        },
      },
    },
    {
      opposite: true,
      linkedTo: 0,
      lineWidth: 1,
      gridLineWidth: 0,
      title: null,
      tickWidth: 1,
      tickLength: 5,
      tickPosition: 'inside',
      labels: {
        align: 'left',
        x: 10,
        style: {
          color: theme === 'dark' ? '#fff' : '#000',
        },
      },
    },
  ],
  legend: {
    enabled: false,
  },
  plotOptions: {
    area: {
      fillOpacity: 0.2,
      lineWidth: 1,
      step: 'center',
    },
  },
  tooltip: {
    headerFormat: '<span style="font-size=10px;">Price: {point.key}</span><br/>',
    valueDecimals: 2,
  },
  series: [
    {
      name: 'Bids',
      data: orderPrices.map(({ price, volume }, index) => [
        Number(formatEther(String(BigInt(price)))),
        Number(formatEther(String(BigInt(volume)))),
      ]),
      color: '#03a7a8',
    },
    {
      name: 'Asks',
      data: listingPrices.map(({ price, volume }, index) => [
        Number(formatEther(String(BigInt(price)))),
        Number(formatEther(String(BigInt(volume)))),
      ]),
      color: '#fc5857',
    },
  ],
});

const toFixed = (x) => {
  if (Math.abs(x) < 1.0) {
    var e = parseInt(x.toString().split('e-')[1]);
    if (e) {
      x *= Math.pow(10, e - 1);
      x = '0.' + new Array(e).join('0') + x.toString().substring(2);
    }
  } else {
    var e = parseInt(x.toString().split('+')[1]);
    if (e > 20) {
      e -= 20;
      x /= Math.pow(10, e);
      x += new Array(e + 1).join('0');
    }
  }
  return x;
};

export const CollectionDepthChart = ({ collectionAddress, data }) => {
  const { theme } = useTheme();
  if (!data) return null;

  const { bids, listings } = data[0].data;

  const actualPrice =
    bids?.length && listings?.length
      ? formatEther(
          String(BigInt((Number(bids[bids?.length - 1]?.price) + Number(listings[0]?.price)) / 2)),
        )
      : 0;
  try {
    options(listings, bids, theme, actualPrice);
  } catch (error) {
    console.log({ error });
    return null;
  }

  return (
    <ChartContainer>
      <div className='w-full'>
        <HighchartsReact
          highcharts={Highcharts}
          options={options(listings, bids, theme, actualPrice)}
        />
      </div>
    </ChartContainer>
  );
};
